/** @format */

export const lawSubjectsSchema = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'Organization',
			'@id': 'https://www.llb360.com/#organization',
			name: 'LLB360',
			url: 'https://www.llb360.com',
			logo: 'https://www.llb360.com/logo.png',
		},
		{
			'@type': 'EducationalCourse',
			name: 'LLB Law Subjects',
			description:
				'Complete list of LLB law subjects including Constitutional Law, Criminal Law, Contract Law, Tort Law, and Jurisprudence.',
			provider: {
				'@type': 'Organization',
				name: 'LLB360',
				sameAs: 'https://www.llb360.com',
			},
		},
		{
			'@type': 'Article',
			headline: 'All Law Subjects for LLB Students',
			description:
				'Explore all LLB law subjects with structured explanations and exam-oriented learning resources.',
			author: {
				'@type': 'Organization',
				name: 'LLB360',
			},
			publisher: {
				'@type': 'Organization',
				name: 'LLB360',
				logo: {
					'@type': 'ImageObject',
					url: 'https://www.llb360.com/logo.png',
				},
			},
			mainEntityOfPage: {
				'@type': 'WebPage',
				'@id': 'https://www.llb360.com/law-subjects',
			},
			datePublished: '2024-01-01',
			dateModified: new Date().toISOString(),
		},
	],
};
